import { render, staticRenderFns } from "./WorkUpdatesList.vue?vue&type=template&id=040e827c&"
import script from "./WorkUpdatesList.vue?vue&type=script&lang=js&"
export * from "./WorkUpdatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports